export var ESourceActionType = /*#__PURE__*/function (ESourceActionType) {
  ESourceActionType["Change"] = "source/change";
  return ESourceActionType;
}({});